import * as React from "react";
import type { SVGProps } from "react";
const SvgEyeoffIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="eyeoff_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M93.61 93.653a43.093 43.093 0 0 1 60.886 0l128.597 128.64c63.19-39.466 138.454-66.56 226.688-66.56 245.888 0 391.254 210.219 454.955 313.472a81.493 81.493 0 0 1 0 85.675c-31.445 50.944-82.773 127.915-156.245 192.853l121.77 121.728a43.05 43.05 0 1 1-60.885 60.886L739.115 800.128c-63.744 40.363-139.904 68.181-229.334 68.181-245.888 0-391.253-210.176-454.954-313.472a81.536 81.536 0 0 1 0-85.632c31.744-51.498 83.797-129.578 158.506-194.858L93.611 154.58a43.093 43.093 0 0 1 0-60.928zm181.25 242.134-3.584 3.072C209.152 392.96 162.688 459.819 130.347 512c32.341 52.181 78.805 119.04 140.928 173.141 63.018 54.827 141.909 96.384 238.506 96.384 62.635 0 117.803-17.493 166.059-44.714l-85.632-85.675a160.725 160.725 0 0 1-219.605-219.605l-95.787-95.744zm162.218 162.218a73.941 73.941 0 0 0 86.614 86.614l-86.614-86.614zm309.931 188.16 1.28-1.024C810.411 631.04 856.832 564.181 889.216 512c-32.384-52.181-78.805-119.04-140.97-173.141-62.977-54.827-141.867-96.384-238.507-96.384-61.398 0-115.67 16.81-163.286 43.178l400.555 400.555z"
    />
  </svg>
);
export default SvgEyeoffIcon;
